export default {
  inadimplencia: []
}
